if (!customElements.get('custom-select')) {
  customElements.define(
    'custom-select',
    class CustomSelect extends HTMLElement {
      connectedCallback() {
        this.nativeSelect = this.querySelector('select');
        this.trigger = this.querySelector('.product-picker__trigger');
        this.list = this.querySelector('.product-picker__list');
        this.valueLabel = this.querySelector('[data-custom-select-label]');
        this.csOptions = this.querySelectorAll('.product-picker__item');

        this.trigger?.addEventListener('click', () => this.toggle());

        this.csOptions.forEach((opt) => {
          opt.addEventListener('click', () => {
            if (opt.classList.contains('is-disabled')) return;
            this.choose(opt);
          });
        });

        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });

        this.addEventListener('keydown', (e) => this.handleKeydown(e));

        this.nativeSelect?.addEventListener('change', () => this.syncSelected());
      }

      toggle() {
        this.list.classList.contains('is-open') ? this.close() : this.open();
      }

      open() {
        this.list.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.list.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
      }

      choose(item) {
        const value = item.dataset.value;
        if (!value) return;

        if (this.nativeSelect) this.nativeSelect.value = value;
        this.syncSelected();

        if (this.valueLabel) {
          this.valueLabel.textContent =
            item.querySelector('.product-picker__item-label')?.textContent.trim() || value;
        }

        this.nativeSelect?.dispatchEvent(new Event('change', { bubbles: true }));
        this.close();
      }

      syncSelected() {
        const current = this.nativeSelect?.value;
        this.csOptions.forEach((opt) => {
          const isSelected = opt.dataset.value === current;
          opt.classList.toggle('is-selected', isSelected);
          opt.setAttribute('aria-selected', String(isSelected));
        });
        if (this.valueLabel && current) {
          const matched = [...this.csOptions].find((o) => o.dataset.value === current);
          if (matched) {
            this.valueLabel.textContent =
              matched.querySelector('.product-picker__item-label')?.textContent.trim() || current;
          }
        }
      }

      handleKeydown(e) {
        const isOpen = this.list.classList.contains('is-open');
        const available = [...this.csOptions].filter((o) => !o.classList.contains('is-disabled'));
        const currentIdx = available.findIndex((o) => o.classList.contains('is-selected'));

        switch (e.key) {
          case 'Enter':
          case ' ':
            if (!isOpen) {
              this.open();
            } else {
              available[currentIdx]?.click();
            }
            e.preventDefault();
            break;
          case 'Escape':
            this.close();
            this.trigger?.focus();
            break;
          case 'ArrowDown':
            e.preventDefault();
            if (!isOpen) this.open();
            available[Math.min(currentIdx + 1, available.length - 1)]?.click();
            break;
          case 'ArrowUp':
            e.preventDefault();
            available[Math.max(currentIdx - 1, 0)]?.click();
            break;
        }
      }
    }
  );
}
